import { Board, Column } from '@gamma/ui/layout';
import { NavTab, NavTabs } from '@gamma/ui/tabs';
import { Outlet } from 'react-router';
import { PageHeader } from '../../../../shared/components';
import { ROUTES } from '../../../../shared/constants/routes';
import { i18n } from '../../../../shared/localization';

export const UsersAndAccess = () => {
  const { title, panels } = i18n.pages.usersAccess;
  const { tabTitle } = i18n.pages.access;

  const tabs: NavTab[] = [
    {
      title: panels.users.heading,
      to: ROUTES.adminUsers,
      isDisabled: false,
    },
    {
      title: tabTitle,
      to: ROUTES.adminAccess,
      isDisabled: false,
    },
  ];

  return (
    <Board>
      <Column>
        <PageHeader>{title}</PageHeader>
        <NavTabs tabs={tabs} isFitted={false} variant="line" basePath="/" />
      </Column>
      <Column
        flexGrow={1}
        display="flex"
        flexBasis="auto"
        flexDirection="column"
      >
        <Outlet />
      </Column>
    </Board>
  );
};
